export default function auth({ next, router }) {
    if (
        !localStorage.getItem("pormoto_token") &&
        !localStorage.getItem("pormoto_userId")
    ) {
        return router.push({ name: "Login" });
    }
    return next();
}
